import LogReaderNode from './types/log-reader';

export const elasticsearchNodes = {
  logReader: LogReaderNode,
};
